import { ArrowUpRight, Sparkles, PenTool } from "lucide-react";
import { Reveal } from "./Reveal";
import { WEBSITES, WEB_NOTE } from "../../data/content";

export const WebDesign = () => (
  <section id="web" data-testid="web-section" className="bg-ink text-paper">
    <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-40">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <Reveal className="max-w-3xl">
          <p className="overline text-terracotta flex items-center gap-2">
            <PenTool size={14} /> (05.5) Web Design
          </p>
          <h2 className="mt-6 font-serif text-5xl md:text-7xl tracking-tight leading-[0.95]">
            Hand-built,
            <br />
            pixel by pixel.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="max-w-md rounded-2xl border border-white/15 bg-white/[0.04] p-6">
            <p className="flex items-start gap-3 text-sm md:text-base text-white/70 leading-relaxed">
              <Sparkles size={18} className="mt-1 shrink-0 text-sage" />
              {WEB_NOTE}
            </p>
          </div>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {WEBSITES.map((s, i) => (
          <Reveal key={s.key} delay={i * 0.1}>
            <a
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`web-site-${s.key}`}
              className="group block overflow-hidden rounded-2xl border border-white/12 bg-white/[0.03] hover:-translate-y-1.5 hover:border-white/30 transition-[transform,border-color] duration-500"
            >
              {/* browser chrome */}
              <div className="flex items-center gap-2 px-4 py-3 border-b border-white/10 bg-white/[0.03]">
                <span className="w-2.5 h-2.5 rounded-full bg-terracotta/80" />
                <span className="w-2.5 h-2.5 rounded-full bg-sage/70" />
                <span className="w-2.5 h-2.5 rounded-full bg-white/25" />
                <span className="ml-3 truncate text-[0.65rem] tracking-wide text-white/40">
                  {s.url.replace("https://", "")}
                </span>
              </div>
              <div className="relative aspect-[4/3] overflow-hidden bg-black">
                <img
                  src={s.img}
                  alt={`${s.title} website`}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-[1200ms] ease-out group-hover:object-bottom"
                />
              </div>
              <div className="flex items-center justify-between px-6 py-5">
                <div>
                  <h3 className="font-serif text-2xl tracking-tight leading-none">{s.title}</h3>
                  <p className="mt-1.5 text-[0.65rem] uppercase tracking-[0.16em] text-white/45">
                    {s.tag}
                  </p>
                </div>
                <span className="grid place-items-center w-10 h-10 rounded-full bg-white/8 text-paper group-hover:bg-terracotta group-hover:rotate-0 transition-colors duration-300">
                  <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
